import { loc, LocText } from "../i18n/survey";

function isNullOrUndefined(
  value: any | null | undefined,
): value is null | undefined {
  return value === null || value === undefined;
}

// The template's description is always overridden by the statement each
// rating question shows; the "Strongly Disagree" / "Strongly Agree" labels the
// visitor sees come from App.scss (fieldset::before/::after).
const ratingQuestionTemplate = {
  isRequired: true,
  type: 'rating',
  displayMode: 'buttons',
  description: '<span class="rating-question-left">Strongly Disagree</span><span class="rating-question-right">Strongly Agree</span>',
  rateMin: 1,
  rateMax: 5,
  descriptionLocation: 'underTitle',
  // minRateDescription: 'Strongly Disagre',
  // maxRateDescription: 'Strongly Agree',
}

/** Several loc() texts combined into one SurveyJS string, per language. */
function locCompose(keys: string[], build: (...texts: string[]) => string): LocText {
  const parts = keys.map((key) => loc(key));
  const text: LocText = { default: build(...parts.map((p) => p.default)) };
  if (parts.every((p) => p.es !== undefined)) text.es = build(...parts.map((p) => p.es as string));
  return text;
}

/** loc() with i18next-style {{name}} placeholders filled in every language. */
function locFormat(key: string, values: Record<string, string | number>): LocText {
  const fill = (s: string) => s.replace(/\{\{(\w+)\}\}/g, (m, name) => (name in values ? String(values[name]) : m));
  const text = loc(key);
  return text.es === undefined ? { default: fill(text.default) } : { default: fill(text.default), es: fill(text.es) };
}

/**
 * The quiz's icon-button choice: optional emoji, a label and a small-text
 * detail line, from `<key>.label` and `<key>.detail`.
 */
function locIconButton(key: string, emoji?: string): LocText {
  return locCompose([`${key}.label`, `${key}.detail`], (label, detail) =>
    emoji === undefined
      ? `<div class='icon-button'><div>${label}<br /><span class="small-text">${detail}</span></div></div>`
      : `<div class='icon-button'><div>${emoji}</div><div>${label}<br /><span class="small-text">${detail}</span></div></div>`
  );
}

export {
  isNullOrUndefined,
  locCompose,
  locFormat,
  locIconButton,
  ratingQuestionTemplate,
}
